module.exports = "pegasus/assets/blocks/header-social.png";